import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ScrollProxyService {
    private readonly scrollSubject$ = new Subject<void>();
    private readonly resetSubject$ = new Subject<void>();

    onScroll$ = this.scrollSubject$.asObservable();
    onReset$ = this.resetSubject$.asObservable();

    scroll() {
        this.scrollSubject$.next();
    }
    reset() {
        this.resetSubject$.next();
    }
}
